var OPERATORS = {
    '=': function (value1, value2) { return value1 == value2; },
    '!=': function (value1, value2) { return value1 != value2; },
    'does exist': function (value1) { return !!value1; },
    'does not exist': function (value1) { return !value1; },
    '<': function (value1, value2) {
        return value1 && value2 ? Number(value1) < Number(value2) : false;
    },
    '>': function (value1, value2) {
        return value1 && value2 ? Number(value1) > Number(value2) : false;
    },
    '>=': function (value1, value2) {
        return value1 && value2 ? Number(value1) >= Number(value2) : false;
    },
    '<=': function (value1, value2) {
        return value1 && value2 ? Number(value1) <= Number(value2) : false;
    },
    // eslint-disable-next-line
    'included': function (value1, value2) {
        if (value1 && value2) {
            var values = parseArray(value2);
            return values ? values.includes(value1) : false;
        }
        return false;
    },
    'is not included': function (value1, value2) {
        if (value1 && value2) {
            var values = parseArray(value2);
            return values ? !values.includes(value1) : false;
        }
        return false;
    },
    'has role': function (value1, value2) {
        if (value1 && value2) {
            var values = parseRoles(value1);
            return values ? values.includes(value2) : false;
        }
        return false;
    },
};
OPERATORS['is greater than or equal'] = OPERATORS['>='];
OPERATORS['is equal or greater than'] = OPERATORS['>='];
OPERATORS['is greater than'] = OPERATORS['>'];
OPERATORS['is lesser than or equal'] = OPERATORS['<='];
OPERATORS['is equal or lesser than'] = OPERATORS['<='];
OPERATORS['is lesser than'] = OPERATORS['<'];
OPERATORS['is not'] = OPERATORS['!='];
OPERATORS.is = OPERATORS['='];
var sanitizeInput = function (rawInput) {
    return rawInput && !rawInput.includes('{') //if the value is not interpolated
        ? rawInput.replace(/ +/g, ' ').trim()
        : '';
};
var parseArray = function (input) {
    if (!input) {
        return null;
    }
    var re = /\[(.*)\]/;
    var matches = input.match(re);
    if (matches && matches[1]) {
        var values = matches[1].split(',');
        return values;
    }
    return null;
};
var parseRoles = function (input) {
    if (!input) {
        return null;
    }
    var values = input.split(',');
    return values;
};
var compareValuesOperator = function (value1Raw, operatorRaw, value2Raw) {
    if (value1Raw === void 0) { value1Raw = ''; }
    if (operatorRaw === void 0) { operatorRaw = 'does exist'; }
    var value1 = sanitizeInput(value1Raw);
    var operator = sanitizeInput(operatorRaw);
    var value2 = sanitizeInput(value2Raw);
    var compareFunction = OPERATORS[operator];
    return compareFunction ? compareFunction(value1, value2) : false;
};

export { compareValuesOperator };
